import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const CustomerGroupSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Customer Group Data from Google Sheets"
      syncType={SyncType.CustomerGroup}
      pageId={PageId.CustomerGroup}
      defaultSheetUrl={defaultSheets.CustomerGroup.defaultSheetUrl}
      defaultRange={defaultSheets.CustomerGroup.defaultRange}
    />
  );
};

export default CustomerGroupSyncPage;
